import { Label } from "../Label/component";
import { baseClass, playBtn, captionsIcon } from "./constants";
import {
    getFormattedDuration,
    getTimeSince,
} from "../../utils/dateTime/library.js";
import { number, oneOf, bool, string } from "prop-types";
import classNames from "classnames";
import { getIsLiveStream } from "../../utils/dataTransform/ContentItem/library";

/**
 * The VideoLinkImageOverlay component.
 *
 * Adds play button icon and video information over images on cards that link to video pages or pages with video headline media.
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the VideoLinkImageOverlay component
 */
export default function VideoLinkImageOverlay({
    videoCardOverlayType = "",
    videoDuration = null,
    videoAirDate = null,
    videoHasCaptions = false,
    videoStreamType = null,
}) {
    const videoStoryClasses = classNames(baseClass);

    if (videoCardOverlayType === "") {
        return null;
    }
    const isLiveStream = getIsLiveStream(videoStreamType);
    const isMinimal = videoCardOverlayType === "Minimal";
    const isLiveOrUpcoming = !isMinimal && isLiveStream && videoAirDate;
    const isLive = isLiveOrUpcoming && videoAirDate < Date.now();
    const isUpcoming = isLiveOrUpcoming && !isLive;
    const ccDiv = videoHasCaptions ? captionsIcon : null;
    const displayDuration = !isMinimal && !isLiveStream;

    let videoDurationDiv = null;
    const videoDurationFormatted = getFormattedDuration(videoDuration);
    if (displayDuration && videoDurationFormatted) {
        videoDurationDiv = (
            <div className={baseClass + "VideoDuration"}>
                <p aria-label={`duration ${videoDurationFormatted}`}>
                    {videoDurationFormatted}
                </p>
                {ccDiv}
            </div>
        );
    }

    let liveOrUpcomingJsx = null;
    if (isLive) {
        liveOrUpcomingJsx = (
            <div className={baseClass + "LiveLabel"}>
                <Label flag="Live" />
                {ccDiv}
            </div>
        );
    } else if (isUpcoming) {
        liveOrUpcomingJsx = (
            <div
                className={classNames(
                    videoHasCaptions ? "captions" : "",
                    baseClass + "Upcoming"
                )}
            >
                <div>
                    <Label flag="Live in" highlighted={true} />
                    {ccDiv}
                </div>
                <p
                    className={baseClass + "UpcomingTime"}
                    suppressHydrationWarning={true}
                >
                    {getTimeSince(videoAirDate)}
                </p>
            </div>
        );
    }

    return (
        <div
            className={videoStoryClasses}
            data-testid="video-link-image-overlay"
        >
            {playBtn}
            <span className="a11y" data-testid="playBtn-a11y">
                Video
            </span>
            {videoDurationDiv}
            {liveOrUpcomingJsx}
        </div>
    );
}

VideoLinkImageOverlay.propTypes = {
    videoCardOverlayType: oneOf(["", "Minimal", "Normal"]),
    videoDuration: number,
    videoAirDate: number,
    videoHasCaptions: bool,
    videoStreamType: string,
};
